import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { useAppContext } from '@contexts/app';
import { DivisionsDropdownProps, DivisionsDropdownRespSuccess } from './types';
import { useQueryParams } from '@hooks/queryParams';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';

export const useDivisionsDropdown = ({ workflowId }: DivisionsDropdownProps) => {
  const { panel } = usePanel();
  const { tenantId } = useParams();
  const {
    isDropdownEnabled: enabled,
    admin: { isLogged },
  } = useAppContext();
  const { parseParams } = useQueryParams();

  const queryParams = parseParams({
    workflowId: !panel ? workflowId : undefined,
    tenantId: panel ? tenantId : undefined,
  });

  const { data, error, isPending } = useQuery<DivisionsDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.divisions, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/divisions${queryParams}`, panel }),
    placeholderData: (previousData) => previousData as DivisionsDropdownRespSuccess,
    enabled: Boolean(panel ? tenantId && isLogged : enabled),
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && Boolean(panel ? tenantId && isLogged : enabled),
  };
};
